import { translate } from '../../helpers/locale-helpers';

export const improvementTypeTranslations = () => ({
    AsIs: translate('Improvement - AsIs'),
    FirstLatest: translate('Improvement - FirstLatest'),
    HighestLatest: translate('Improvement - HighestLatest'),
    FirstHighest: translate('Improvement - FirstHighest')
});



// WEBPACK FOOTER //
// ./components/improvement-type-picker/improvement-type-translations.js